/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { name, bank, bank_account, short_description, email, phone, address, business_email, business_address, business_phone, business_name, specialty, badge, password, password_confirmation, account_name, account_email, rfc },
} = checkout;

const validations = Yup.object().shape({
  [name.name]: Yup.string().required(name.errorMsg),
  [short_description.name]: Yup.string().required(short_description.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg).email(email.invalidMsg),
  [phone.name]: Yup.string().required(phone.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  [business_name.name]: Yup.string().required(address.errorMsg),
  [business_address.name]: Yup.string().required(business_address.errorMsg),
  [business_email.name]: Yup.string().required(business_email.errorMsg).email(business_email.invalidMsg),
  [business_phone.name]: Yup.string().required(business_phone.errorMsg),
  [specialty.name]: Yup.string().required(specialty.errorMsg),
  [badge.name]: Yup.string().required(badge.errorMsg),
  [password.name]: Yup.string().required(password.errorMsg),
  [password_confirmation.name]: Yup.string().required(password_confirmation.errorMsg).oneOf([Yup.ref("password")], password_confirmation.invalidMsg),
  [bank.name]: Yup.string().required(bank.errorMsg), // if bank is required
  [account_name.name]: Yup.string().required(account_name.errorMsg),
  [account_email.name]: Yup.string().required(account_email.errorMsg).email(email.invalidMsg),
  [rfc.name]: Yup.string().required(rfc.errorMsg),
  [bank_account.name]: Yup.string()
      .required(bank_account.errorMsg) // if bank_account is required
      .length(18, 'Debe de contener 18 números') // if bank_account should be exactly 18 digit
      .matches(/^\d+$/, 'Solo puede incluir números'),
});

export default validations;
